import React, { PureComponent } from 'react';
import { pagesApi } from '../../apis/PagesApi';
import ReactHtmlParser from 'react-html-parser';

class ContactPage extends PureComponent {
   state = {
      email: '',
      phone: '',
      address: '',
      map_url: '',
   }

   componentDidMount() {
      this.loadData();
   }

   loadData = async () => {
      const response = await pagesApi.getPageContact();
      if (response && response.id) {
         this.setState({
            email: response.email || '',
            phone: response.phone || '',
            address: response.address || '',
            map_url: response.map_url || '',
         });
      }
   }

   render() {
      return (
         <div className="contact-page">
            {
               this.state.map_url &&
               <div className="embed-map-frame">
                  {ReactHtmlParser(this.state.map_url)}
               </div>
            }
            <div className="contact-info">
               <span className="info-text">HO CHI MINH CITY, VIETNAM</span>
               {
                  this.state.address &&
                  <span className="info-text">{this.state.address}</span>
               }
               {
                  this.state.email &&
                  <span className="info-text"><span className="before-text">@:</span>
                     <a href={`mailto:${this.state.email}`}>{this.state.email}</a>
                  </span>
               }
               {
                  this.state.phone &&
                  <span className="info-text"><span className="before-text">T:</span>
                     <a href={`tel:${this.state.phone}`}>{this.state.phone}</a>
                  </span>
               }
            </div>
         </div>
      );
   }
}

export default ContactPage;